import Footer from "./Footer"
import Header from "./Header"
import SidebarCart from "./sidebars/SidebarCart"
import SidebarIndividualChat from "./sidebars/SidebarIndividualChat"
import SidebarNotifications from "./sidebars/SidebarNotifications"
console.log('=== SIDEBAR NOTIFICATIONS IMPORT TEST ===');
console.log('SidebarNotifications component:', SidebarNotifications);
import ChatToggle from "./commons/ChatToggle"
import LiveChat from "./commons/LiveChat"
import { useState } from "react"
import { useAuth } from "../context/authContext"

const Layout = ({ children }) => {
    console.log('=== LAYOUT COMPONENT RENDER ===');
    
    const { user } = useAuth();
    const [isChatOpen, setIsChatOpen] = useState(false);

    const handleChatToggle = () => {
        setIsChatOpen(!isChatOpen);
    };

    return (
        <>
            <Header />

            <SidebarCart />
            <SidebarIndividualChat />
            <SidebarNotifications />

            <div className="container mx-auto px-5 pt-36 pb-24 relative">
                {children}
            </div>

            {/* Live Support Chat */}
            {user && (
                <>
                    <ChatToggle onClick={handleChatToggle} />
                    <LiveChat isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
                </>
            )}

            <Footer />
        </>
    )
}

export default Layout